import { useDatePickerHelpers } from "@newsela/angelou";
import type { CalendarDate, ZonedDateTime } from "@internationalized/date";

type UseScheduleAssign = (args: {
  dateGoesLive: string | undefined;
  originalDateGoesLive: string | undefined;
  maxScheduleDate: string | undefined;
}) => {
  scheduledDateTime: ZonedDateTime;
  minValue: ZonedDateTime | CalendarDate;
  resetDate: ZonedDateTime;
  maxValueAttribute:
    | Record<string, never>
    | {
        maxValue: ZonedDateTime;
      };
};

export const useScheduleAssign: UseScheduleAssign = ({
  dateGoesLive,
  originalDateGoesLive,
  maxScheduleDate,
}) => {
  const { getLocalTimeZone, now, today, parseAbsoluteToLocal } =
    useDatePickerHelpers();

  const timeZone = getLocalTimeZone();
  const currentLocalDateTime: ZonedDateTime = now(timeZone);
  const currentDate: CalendarDate = today(timeZone);

  const scheduledDateTime = originalDateGoesLive
    ? parseAbsoluteToLocal(originalDateGoesLive)
    : currentLocalDateTime;

  const zonedDateGoesLive = dateGoesLive && parseAbsoluteToLocal(dateGoesLive);

  /* The minValue that can be selected on the calendar should be set to whichever data is the earliest between the saved dateGoesLive for the assignment, the current date and the selected date. */

  const minValue = [scheduledDateTime, currentDate, zonedDateGoesLive].sort(
    (a, b) => a?.toDate()?.getTime() - b?.toDate()?.getTime(),
  )[0];

  const resetDate = originalDateGoesLive
    ? parseAbsoluteToLocal(originalDateGoesLive)
    : currentLocalDateTime;

  const maxValueAttribute = maxScheduleDate
    ? { maxValue: parseAbsoluteToLocal(maxScheduleDate) }
    : {};
  return { scheduledDateTime, minValue, resetDate, maxValueAttribute };
};
